import clsx from 'clsx';
import { ReactNode } from 'react';

import { panel, panels, selectedPanel } from './tabs.css';

type TabPanelsProps<T> = {
  data: T[];
  selected: string;
  value: (el: T) => string;
  classNames?: { panels?: string; panel?: string };
  children: (el: T) => ReactNode;
};

export function TabPanels<T>({
  data,
  children,
  selected,
  value,
  classNames,
}: TabPanelsProps<T>) {
  return (
    <section className={clsx(panels, classNames?.panels)}>
      {data.map((el) => (
        <section
          className={clsx(panel, classNames?.panel, {
            [selectedPanel]: value(el) === selected,
          })}
          key={value(el)}
        >
          {children(el)}
        </section>
      ))}
    </section>
  );
}
